import React, { useState, useCallback, useContext, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { CSVLink } from "react-csv";
import { styles } from "./styles";
import * as moment from "moment";
import { toast } from "react-toastify";
import { toastCss } from "assets/styleJS/global";
import {
  withStyles,
  createMuiTheme
} from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Link from "@material-ui/core/Link";
import { dormanteader } from "./Headers/headers";
import Loader from "components/Loader/Loader";
import Context from "context/context";
import dormantApi from "apis/auditTier/auditTier";
import { useHistory } from "react-router";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
// import CSVReader from 'react-csv-reader';
import ExampleCsvFile from './dormant_process.csv';
import TextField from "@material-ui/core/TextField";
const Papa = require("papaparse/papaparse.min.js");



const GlobalCss = withStyles({
  "@global": {
    " .MuiDialog-scrollPaper": {},
    ".MuiDialog-paperWidthSm": {
      overflow: "hidden",
      maxWidth: "none",
    },
    " .MuiDialog-paper ": {},
    ".MuiFormLabel-root": {
      color: "black",
    },
  },
})(() => null);

export default function DormantAutomation(props) {
  const classes = styles();
  const { uploadDormant,uploadDormantcancel,uploadDormantexecute } = dormantApi();
  const { state, dispatch } = useContext(Context);
  const history = useHistory();
  const { t, i18n } = useTranslation();
  const [states, setstates] = useState({
    columns: [],
    // currentYear: "",
    dialog: false,
    data: [],
    selectedFields: [],
    loading: false,
    sucessdata : false,
    count: "",
    executetime : 10
  });
  
  const [selectedFile, setSelectedFile] = useState('');

  // For bread-crumbs
  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "Dormant Automation"],
    });
  }, []);

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  let selectedColumns = dormanteader.map((header) => header.label);

  function handleChange(event) {
    setSelectedFile(event.target.files[0].name);
    selectedColumnFun();
    importCSV(event.target.files[0]);
  }

  function updateData(result) {
    var data = result.data;
    preparePayload(data);
  }

  function importCSV(csvFile) {
    Papa.parse(csvFile, {
      complete: updateData,
      header: true,
    });
  }
 


  function preparePayload(data) {
    const payload = [];
  
    data.forEach((row) => {
      // Skip rows where loyalty_id is empty
      if (!row.loyalty_id || row.loyalty_id.trim() === "") return;
  
      payload.push({
        loyalty_id: row.loyalty_id.trim(),
      });
    });
  
    if (payload.length === 0) {
      toast.error("*Please import valid csv file", {
        ...toastCss,
        autoClose: 5000,
      });
      document.getElementById("demo").value = null;
    }
  
    setStates({ data: payload });
  }

  console.log(states.data,"states.data")

  const handleUploadDriveToThrive = async () => {
    try {
      let values = {
        data: states.data,
       
      };
      setStates({ loading: true });
      console.log(values)
      let res = await uploadDormant(values);
      setStates({ loading: false });
      if (res.status_code == 200) {
        setStates({
          dialog: false,
          data: [],
          count:res.count
        });
        document.getElementById("demo").value = null;
        setStates({ sucessdata: true });
        setStates({ count: res.count });
        return toast.success(res.message);

      
      } 
      else{
        return toast.error(res.message);

      }
    } 
    catch (err) {
      setStates({ loading: false });
      console.log(err);
    }
  };

  const handleUploadcancel = async () => {
    try {
     
     
     
      setStates({ loading: true });
      let res = await uploadDormantcancel();
      if (res.status_code == 200) {
        setStates({ loading: false });
        setStates({
          dialog: false,
          data: [],
          sucessdata:false,
          count:0
        });
        document.getElementById("demo").value = null;
        return toast.success(res.message);
      }
      else{
        setStates({ loading: false });
        return toast.error(res.message);
        


      }
     
    } 
    catch (err) {
      setStates({ loading: false });
      console.log(err);
    }
  };

  const handleUploadexecute = async () => {

    if(!states?.executetime){
      return toast.error("Please select execute time");
    }
    try {
      let values = {
        data: states.executetime,
       
      };
     
     
      setStates({ loading: true });
      let res = await uploadDormantexecute(values);
      if (res.status_code == 200) {
        setStates({ loading: false });
        setStates({sucessdata:false,data:[],count:0})
        return toast.success(res.message);
      }
      else{
        setStates({ loading: false });
        setStates({sucessdata:false,data:[],count:0})
        return toast.error(res.message);
       
       


      }
     
    } 
    catch (err) {
      setStates({ loading: false });
      setStates({sucessdata:false,data:[],count:0})
      console.log(err);
    }
  };


  function selectedColumnFun() {
    {
      setStates({ data: [] });
      let data = [];
      dormanteader.map((header, i) => {
        if (selectedColumns?.includes(header.label)) {
          data = [...data, header.key];
          return;
        }
      });
      setStates({ selectedFields: data });
    }
  }

  return (
    <React.Fragment>
      <GlobalCss />      
      <div>
        <Grid container spacing={0}>          
          <Grid
            item
            xs={12}
            style={{ textAlign: "center", fontSize: 20, padding: 10 }}
          >
            <span style={{ fontWeight: "bold" }}>
              {" "}
              Dormant Automation
            </span>
          </Grid>
          {/* <Grid
            item
            xs={12}
            style={{ textAlign: "right", fontSize: 18, padding: 10 }}
          >
            <span style={{ fontWeight: "bold" }}>Import Date : </span>
            <span>{moment(new Date()).format("YYYY-MM-DD")}</span>
          </Grid> */}
          <Grid
            item
            xs={6}
            style={{ textAlign: "left", fontSize: 12, padding: 10 }}
          >
            <span style={{ fontWeight: "normal" }}>
              * Please import csv file (
                <Link
                  href={ExampleCsvFile}
                  download="dormant_process"
                  target="_blank"
                >
                  Click here to download sample .csv file
                </Link>
              )
            </span>
          </Grid>
          {states.count && states.count > 0 ? (
            <Grid
              item
              xs={6}
              style={{ textAlign: "right", fontSize: 14, padding: 10 }}
            >
              <span style={{ fontWeight: "normal" }}>
                {" "}
                Total Count : {states.count}
              </span>
            </Grid>
          ) : (
            ""
          )}
        </Grid>        
      </div>
     
              <Grid container spacing={0}>
                <Grid
                  item
                  xs={12}
                  md={6}
                  lg={6}
                  className={classes.headingText2Grid}
                >
                   {states.sucessdata==true && (
                    <TextField
                                            id="Executetime"
                                            label={
                                                <span>
                                                    {t('Execute Time (mins)')} <span style={{ color: 'red' }}>*</span>
                                                </span>
                                            }

                                            fullWidth
                                            type="text"
                                            value={states?.executetime}
                                            onChange={(e) => {
                                              setStates({
                                                executetime:e.target.value
                                              });
                                            }}
                                        >

                                        </TextField>
                                           )}
                </Grid>
             
                <Grid
                  item
                  xs={12}
                  md={6}
                  lg={6}
                  className={classes.headingText2Grid}
                >
                  <div>
                    <input
                      id="demo"
                      type="file"
                      accept=".csv"
                      placeholder="import csv"
                      onChange={handleChange}
                    />
                  </div>
                </Grid>
              </Grid>
      {<Loader Loading={states?.loading}></Loader>}
    
        <Grid container spacing={0}>
          <Grid item xs={12} style={{ padding: 20, textAlign: "center" }}>
          {states.data && states.data.length > 0 && ( <Button
              className={
                states?.loading ? classes.uploadBtnDisabled : classes.uploadBtn
              }
              onClick={handleUploadDriveToThrive}
              disabled={states?.loading}
            >
             
                                {states?.loading ? "loading..." : "Upload"}
            </Button>    )}
            {((states.data && states.data.length > 0) ||states.sucessdata==true )&& (
            <Button
              className={classes.cancelBtn}
              disabled={states?.loading}
              onClick={() => {
                setStates({
                  dialog: false,
                  data: [],
                });
                document.getElementById("demo").value = null;
                handleUploadcancel()
              }}
            >
              {states?.loading ? "loading..." : "Cancel"}
            </Button> )}
            {states.sucessdata==true && (
            <Button
              className={
                states?.loading ? classes.uploadBtnDisabled : classes.uploadBtn
              }
              disabled={states?.loading}
              onClick={handleUploadexecute}
            >
               {states?.loading ? "loading..." : "Execute"}
            </Button> )}
            
          </Grid>
        </Grid>
  
 
         
           
      
    </React.Fragment>
  );
}
